import {isNil} from 'lodash';
import {ReactNode} from 'react';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import {ReactQueryFetcher} from '../../../../../../reactQuery/ReactQueryFetcher';
import {useMyRatingQuery} from '../../../../../../wrapper';
import {setMyRating} from '../state/viewerEndSlice';

export interface MyRatingFetcherHeadlessProps {
  seriesId: number;
  productId: number;
  children?: ReactNode;
}

export function MyRatingFetcherHeadless({
  seriesId,
  productId,
}: MyRatingFetcherHeadlessProps) {
  const dispatch = useTypedDispatch();

  return (
    <ReactQueryFetcher
      reactQuery={useMyRatingQuery}
      variables={{seriesId, productId}}
      ignoreLoading={true}
      ignoreFetching={true}
      onSuccess={data => {
        const myRating = data.myRating?.myRating;
        if (!isNil(myRating)) {
          dispatch(setMyRating({productId, myRating}));
        }
      }}
      // MyRating API가 실패해도 별도의 에러처리를 하지 않습니다.
      onError={() => {}}
    />
  );
}
